import { DEFAULT_LOCALE, type Locale } from "./config";

// Cada vista/componente tiene su archivo de textos al lado (page.i18n.ts,
// Header.i18n.ts...) con un bloque por idioma:
//
//   export default defineMessages({
//     es: { title: "Eventos", count: (n: number) => `${n} eventos` },
//     en: { title: "Events",  count: (n: number) => `${n} events` },
//   });
//
// El bloque del idioma por defecto (es) define la forma; NoInfer hace que los
// demás se validen contra él: si a `en` le falta una clave, o trae una de más,
// no compila. Los valores pueden ser strings o funciones (interpolación,
// plurales) — por eso los textos se usan directo, sin claves en strings.
type OtherLocale = Exclude<Locale, typeof DEFAULT_LOCALE>;

export type Messages<T> = { [K in typeof DEFAULT_LOCALE]: T } & { [K in OtherLocale]: NoInfer<T> };

export function defineMessages<T extends object>(messages: Messages<T>): Messages<T> {
  return messages;
}

// Para componentes de servidor (reciben `lang` por params o por prop).
export function getMessages<T>(messages: Messages<T>, lang: Locale): T {
  return (messages as Record<Locale, T>)[lang];
}
